import React, { useContext } from 'react';
import Contents from './contents';
import githubLogo from '~/assets/img/logo-github.svg';
import bitbucketLogo from '~/assets/img/logo-bitbucket.svg';
import gitlabLogo from '~/assets/img/logo-gitlab.svg';
import emailLogo from '~/assets/img/email.svg';
import { ArticleContext } from '~/context/articleContext';
import { getRegisterUrl } from '~/helpers/url';
import CtaClick from '~/components/ctaClick';

const buttons = [
  {
    logo: githubLogo,
    name: 'github',
    displayName: 'GitHub',
    link: getRegisterUrl('github')
  },
  {
    logo: gitlabLogo,
    name: 'gitlab',
    displayName: 'GitLab',
    link: getRegisterUrl('gitlab')
  },
  {
    logo: bitbucketLogo,
    name: 'bitbucket',
    displayName: 'Bitbucket',
    link: getRegisterUrl('bitbucket')
  },
  {
    logo: emailLogo,
    name: 'email',
    displayName: 'Email',
    link: getRegisterUrl()
  }
];

const Aside = () => {
  const { article } = useContext(ArticleContext);

  return (
    <div className="col-md-4 col-lg-3 col-xl-2_5 aside-container">
      <div className="aside">
        <div className="nav-quick">
          <Contents article={article} />
        </div>
        <div className="sign-up-box">
          <h3 className="header header__primary--extra-small mb-2">
            Get started for free
          </h3>
          <p className="text text__primary text__primary--extra-small mb-3">
            Sign up with...
          </p>
          <div className="btn-container">
            {buttons.map((b, i) => (
              <CtaClick key={i} cta={[`sign-up-docs- ${b.name}`]} generalCta={['sign-up-docs']}>
                <a href={b.link} className="btn btn-block mb-3 text-left" key={i}>
                  <img
                    src={b.logo}
                    alt={`Buddy - ${b.name}`}
                    className="btn-icon-element"
                  />
                  {b.displayName}
                </a>
              </CtaClick>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aside;
